export enum StandingsConfigurationTableColumns {
  NameLocal = "nameLocal",
  NameLatin = "nameLatin",
  StandingConfigurationId = "standingConfigurationId",
  ExternalId = "externalId",
}
